import React, { Component } from "react"
import I18n from "../utils/i18n.js"
import ReactDOM from "react-dom"
import _ from 'underscore'
import createReactClass from 'create-react-class'
export default createReactClass({
  getDefaultProps() {
    return {
      refs: null,
      filters: [],
      options: [],
      open_value_filters: ['free_text', 'min_year', 'max_year', 'min_price', 'max_price', 'min_year', 'max_year', 'min_plot_space', 'max_plot_space', 'min_living_space', 'max_living_space'],
      date_filters: ['start_date', 'end_date'],
      blacklist: ['gclid'],
      price_filters: ['max_price', 'min_price']
    };
  },

  createFilter(filter, value) {
    return <div className="facet" data-ref={filter} key={filter}>
        <h2>{value}</h2> <span className="deselect" onClick={this.deselectFacet.bind(this, filter)}>&times;</span>
      </div>;
  },

  formatDate(value) {
    const pattern = /(\d{2})[\--\/](\d{2})[\--\/](\d{4})/;
    const date = Date.parse(value.replace(pattern,'$3-$2-$1'));
    if (isNaN(date)) { return value; }
    return new Intl.DateTimeFormat(window.Gites.locale).format(date);
  },

  deselectFacet(filter) {
    const filters = _.clone(this.props.filters);
    filters.booleans = filters.booleans.filter((k, v) => k !== filter);

    filters.languages = filters.languages.filter((k, v) => k !== filter);

    filters.regions = filters.regions.filter((k, v) => k !== filter);

    filters.departments = filters.departments.filter((k, v) => k !== filter);

    filters.areas = filters.areas.filter((k, v) => k !== filter);

    filters.object_types = filters.object_types.filter((k, v) => k !== filter);

    if (filters[filter]) { delete filters[filter]; }

    return this.props.onDeselect(filters);
  },

  render() {
    const self = this;

    const selected_facets = [];

    _.each(this.props.filters, function(value, key) {
      if (_.contains(self.props.blacklist, key)) { return; }
      if (_.contains(self.props.price_filters, key)) {
        value = new Intl.NumberFormat(I18n.locale, { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value);
      }

      if ((key === 'booleans') || (key === 'languages') || (key === 'subobject_types')) {
        return value.map(function(filter) {
          value = I18n.t(`search.attributes.${filter}`);

          return selected_facets.push(self.createFilter(filter, value));
        });
      } else if ((key === 'regions') || (key === 'departments') || (key === 'areas')) {
        return value.map(filter =>
          value = _.each(self.props.options[key], function(model, key) {
            if (model.slug === filter) { return selected_facets.push(self.createFilter(model.slug, model.name)); }
          })
        );
      } else if (key === 'object_types') {
        return value.map(filter => selected_facets.push(self.createFilter(filter, I18n.t(`search.object_type.${filter}`))));
      } else if (key === 'max_persons') {
        value = value <= 20 ? I18n.t('search.persons_count', {count: value}) : I18n.t('search.more_than_twenty');
        return selected_facets.push(self.createFilter(key, value));
      } else if ((key === 'maintenance') || (key === 'object_sub_type')) {
        return selected_facets.push(self.createFilter(key, I18n.t(`search.${key}.${value}`)));
      } else if (_.contains(self.props.date_filters, key)) {
        value = I18n.t(`search.form_labels.${key}`) + `: ${self.formatDate(value)}`;
        return selected_facets.push(self.createFilter(key, value));
      } else if (_.contains(self.props.open_value_filters, key)) {
        value = I18n.t(`search.form_labels.${key}`)+': '+value;
        return selected_facets.push(self.createFilter(key, value));

      } else if (value) {
        value = I18n.t(`search.attributes.${key}`, {count: value});
        return selected_facets.push(self.createFilter(key, value));
      }
    });

    return <div className="selected-facets">
        {selected_facets}
      </div>;
  }
});
